(function () {
  // ✅ 必填：Shopify Settings → Files 任意图片的 URL，保留到 /files/ 结尾
  const FILES_BASE = "https://cdn.shopify.com/s/files/1/0902/3517/5292/files/";
  const EXT = "png"; // 你上传的是 jpg 就改成 "jpg"

  function getItemText(itemEl) {
    const textEl =
      itemEl.querySelector(
        ".color-swatch__title, .swatch__label, .variant__label, .color-swatch__text"
      ) || null;

    if (textEl && textEl.textContent) return textEl.textContent.trim();

    const aria = itemEl.getAttribute("aria-label") || itemEl.getAttribute("title");
    if (aria) return aria.trim();

    return (itemEl.textContent || "").trim();
  }

  // ✅ 完美兼容模式：既保留原拼写，又做双保险，且不卡顿
  function buildCandidates(text) {
    let raw = String(text || "").trim();
    
    // 统一符号（把特殊乘号换成字母 x，去掉引号等）
    raw = raw.replace(/×/g, "x").replace(/["“”′’]/g, "");

    const candidates = new Set();

    // 辅助函数：快速生成带下划线、不带下划线、以及小写的组合
    const addVariants = (str) => {
      if (!str) return;
      const v1 = str.replace(/\s+/g, "_").replace(/[^0-9a-zA-Z_-]/g, ""); // 变体A: Digtal_File
      const v2 = str.replace(/\s+/g, "").replace(/[^0-9a-zA-Z_-]/g, "");  // 变体B: DigtalFile
      
      if (v1) {
        candidates.add(v1);
        candidates.add(v1.toLowerCase()); // digtal_file
      }
      if (v2) {
        candidates.add(v2);
        candidates.add(v2.toLowerCase()); // digtalfile
      }
    };

    // 1. 首先，原汁原味地生成猜测（完全尊重页面上的拼写，哪怕是 Digtal）
    addVariants(raw);

    // 2. 双保险：如果页面上是 digtal，再额外增加一组 digital 的猜测
    // 这样无论你后台的图片叫 Digtal_File 还是 Digital_File 都能瞬间找到！
    if (/digtal/i.test(raw)) {
      addVariants(raw.replace(/digtal/gi, "digital"));
    }

    // 转换为数组返回
    return Array.from(candidates);
  }

  function getSwatchGroups() {
    return Array.from(document.querySelectorAll(".color-swatches-container"));
  }

  function getSwatchItems(groupEl) {
    return Array.from(groupEl.querySelectorAll("label.color-swatch, .color-swatch"));
  }

  function applyImageToSwatch(itemEl, url) {
    const img =
      itemEl.querySelector("img") ||
      itemEl.querySelector(".color-swatch__image img") ||
      null;

    if (img) {
      img.src = url;
      img.srcset = "";
      img.setAttribute("data-files-src", url);
    }

    const bgTarget =
      itemEl.querySelector(".color-swatch__image") ||
      itemEl.querySelector(".color-swatch__custom-color") ||
      itemEl.querySelector(".color-swatch__value") ||
      itemEl;

    if (bgTarget) {
      bgTarget.style.backgroundImage = `url("${url}")`;
      bgTarget.style.backgroundSize = "cover";
      bgTarget.style.backgroundPosition = "center";
      bgTarget.style.backgroundRepeat = "no-repeat";
    }
  }

  // 并发抢答模式：找到第一个存在的图就立刻显示，剩下的静默作废
  function setSwatchFromFiles(itemEl, candidates) {
    if (!FILES_BASE) return;
    if (!candidates || !candidates.length) return;

    const key = candidates.join("|");
    if (itemEl.getAttribute("data-files-key") === key) return;
    itemEl.setAttribute("data-files-key", key);

    let isResolved = false;

    candidates.forEach((name) => {
      const url = `${FILES_BASE}${name}.${EXT}`;
      const probe = new Image();
      
      probe.onload = function () {
        if (!isResolved) {
          isResolved = true; 
          applyImageToSwatch(itemEl, url);
        }
      };
      
      probe.onerror = function () {}; 
      
      probe.src = url; 
    });
  }

  function apply() {
    const groups = getSwatchGroups();
    if (!groups.length) return;

    // 只处理第一组 swatches
    const firstGroup = groups[0];
    const items = getSwatchItems(firstGroup);
    if (!items.length) return;

    items.forEach((item) => {
      const text = getItemText(item);
      if (!text) return;

      const candidates = buildCandidates(text);
      setSwatchFromFiles(item, candidates);
    });
  }

  document.addEventListener("DOMContentLoaded", apply);

  const mo = new MutationObserver(() => apply());
  mo.observe(document.documentElement, { childList: true, subtree: true });
})();